<template>
  <div>
    <!-- BRM 数据面板 -->
    <div v-if="aiMode && brmData" class="brm">
      <div class="brm-head">
        <span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--green);box-shadow:0 0 6px var(--green);flex-shrink:0;"></span>
        BRM 数据发现
        <span style="margin-left:auto;font-size:0.64rem;color:var(--text3);">品牌：{{ aiBrand }}</span>
      </div>
      <div class="brm-grid">
        <div class="brm-it ok">
          <div class="bi" style="color:var(--green);">✓</div>
          <div>
            <div class="bl">已收录平台</div>
            <div class="bd">{{ brmPlatformsFound }}</div>
          </div>
        </div>
        <div class="brm-it warn">
          <div class="bi" style="color:var(--amber);">?</div>
          <div>
            <div class="bl">未收录——品牌可能已布局，请确认</div>
            <div class="bd">{{ brmPlatformsNotFound }}</div>
          </div>
        </div>
        <div class="brm-it ok">
          <div class="bi" style="color:var(--green);">✓</div>
          <div>
            <div class="bl">经销商层级</div>
            <div class="bd">最深{{ brmData.maxDealerDepth }}级，{{ brmData.dealerCount }}家经销商</div>
          </div>
        </div>
        <div class="brm-it ok">
          <div class="bi" style="color:var(--green);">✓</div>
          <div>
            <div class="bl">授权管控数据</div>
            <div class="bd">授权{{ brmData.authorizedStores }}家({{ brmData.authRate }}%) · 灰名单{{ brmData.grayListStores }}家({{ 100 - brmData.authRate }}%)</div>
          </div>
        </div>
        <div class="brm-it warn">
          <div class="bi" style="color:var(--amber);">?</div>
          <div>
            <div class="bl">业态分布——仅收录货架电商，请确认</div>
            <div class="bd">可见：货架电商 | 未收录：内容/社交/即时零售/DTC</div>
          </div>
        </div>
        <div class="brm-it warn">
          <div class="bi" style="color:var(--amber);">?</div>
          <div>
            <div class="bl">平台依赖度——店铺数≠GMV，请评估</div>
            <div class="bd">{{ brmMaxPlatformName }}店铺数占总店铺数的{{ brmMaxPlatformPct }}%</div>
          </div>
        </div>
      </div>
      <div class="brm-foot">
        BRM数据来自鹰智渠道管理系统。<span style="color:var(--green);font-weight:600;">绿色项已收录</span>，黄色项需自行判断。
      </div>
    </div>

    <!-- BRM 空状态 -->
    <div v-if="aiMode && !brmData" class="brm">
      <div class="brm-head">
        <span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--amber);box-shadow:0 0 6px var(--amber);flex-shrink:0;"></span>
        BRM 数据查询
        <span style="margin-left:auto;font-size:0.64rem;color:var(--text3);">品牌：{{ aiBrand }}</span>
      </div>
      <div style="padding:20px;text-align:center;">
        <div style="font-size:1.1rem;color:var(--text2);margin-bottom:6px;">该品牌暂未收录至 BRM 系统</div>
        <div style="font-size:0.78rem;color:var(--text3);">诊断将基于 AI 搜索数据生成报告。如需收录，请在鹰智BRM中录入该品牌的渠道信息。</div>
      </div>
    </div>

    <!-- AI 调研详情面板 -->
    <div v-if="aiMode && aiData" class="brm" style="margin-top:0;">
      <div class="brm-head">
        <span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--cyan);box-shadow:0 0 6px var(--cyan);flex-shrink:0;"></span>
        AI调研详情
        <span style="margin-left:auto;font-size:0.64rem;color:var(--text3);">{{ aiBrand }} · 渠道覆盖检测结果</span>
      </div>
      <div class="brm-grid">
        <div
          v-for="item in aiFindingItems"
          :key="item.label"
          class="brm-it"
          :style="findingStyle(item.found)"
        >
          <div class="bi" :style="{ color: item.found ? 'var(--green)' : 'var(--red)' }">
            {{ item.found ? '✓' : '✕' }}
          </div>
          <div>
            <div class="bl">{{ item.label }}</div>
            <div class="bd">{{ item.detail }}</div>
          </div>
        </div>
      </div>
      <div class="brm-foot">数据基于实时联网搜索，覆盖主流线上渠道。绿色=已覆盖 &ensp; 红色=未发现。</div>
    </div>

    <!-- 18题评分表单 -->
    <div
      v-for="dim in dimensions"
      :key="dim.id"
      class="diagnosis-panel"
    >
      <div class="panel-header">
        <span class="pdot cyan"></span>{{ dim.name }}
        <span style="font-size:0.64rem;color:var(--text3);margin-left:4px;">权重 {{ dim.weight }}</span>
        <span style="margin-left:auto;" class="pdots">
          <span
            v-for="i in dim.questions.length"
            :key="i"
            class="d"
            :class="{ f: i <= dimensionProgress(dim.id) }"
          ></span>
        </span>
      </div>
      <div class="panel-body">
        <p class="lead">{{ dim.desc }}</p>
        <div class="qa">
          <div
            v-for="q in dim.questions"
            :key="q.id"
            class="qb"
          >
            <div class="qt">
              {{ q.text }}
              <span v-if="aiMode" :class="aiBadgeClass(q.id)">
                <span class="ab-dot"></span>{{ confidenceLabel(q.id) }}
              </span>
            </div>
            <div class="qd">差：{{ q.low }} ｜ 好：{{ q.high }}</div>

            <!-- AI评分理由 -->
            <div v-if="aiMode && getScore(q.id) && getReason(q.id)" class="bn">
              ◆ AI评估{{ getScore(q.id) }}分：{{ getReason(q.id) }}
              <template v-if="isBrmSource(q.id)">（参考BRM渠道数据）</template>
            </div>

            <!-- 评分按钮 1-5 -->
            <div class="sr">
              <button
                v-for="s in 5"
                :key="s"
                class="s-btn"
                :class="scoreBtnClass(q.id, s)"
                @click="pickScore(q.id, s)"
              >{{ s }}</button>
              <span class="sh">1 = 严重不符 &ensp; 5 = 完全符合</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="btn-row sticky">
      <button class="btn btn-out" @click="resetAll">全部重置</button>
      <button
        class="btn btn-pri"
        :disabled="!allScored"
        @click="generateReport"
      >
        生成诊断报告
        <span v-if="!allScored" style="font-size:0.66rem;font-weight:400;">
          （剩余 {{ remainingCount }} 题）
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { DIMENSIONS, AI_CONFIDENCE, CONFIDENCE_LABELS } from '../../utils/constants'
import { BRAND_DB } from '../../utils/mockData'

export default {
  name: 'ScoresTab',
  computed: {
    ...mapState('diagnosis', ['aiMode', 'aiBrand', 'scores', 'brmSource', 'brmData', 'aiData']),
    ...mapGetters('diagnosis', ['allScored', 'remainingCount', 'dimensionProgress']),
    dimensions() { return DIMENSIONS },

    // BRM计算属性
    brmPlatformsFound() {
      if (!this.brmData) return ''
      return Object.entries(this.brmData.platformDetails || {})
        .map(([k, v]) => `${k} ${v}店`).join(' · ')
    },
    brmPlatformsNotFound() {
      return this.brmData ? (this.brmData.platformsNotFound || []).join(' · ') : ''
    },
    brmMaxPlatformName() {
      if (!this.brmData || !this.brmData.platformDetails) return ''
      let max = { key: '', val: 0 }
      Object.entries(this.brmData.platformDetails).forEach(([k, v]) => {
        if (v > max.val) max = { key: k, val: v }
      })
      return max.key
    },
    brmMaxPlatformPct() {
      if (!this.brmData) return 0
      return Math.round((this._brmMaxVal() / this.brmData.totalStores) * 100)
    },

    // AI Findings
    aiFindingItems() {
      if (!this.aiData || !this.aiData.findings) return []
      const labels = {
        tmall: '天猫', jd: '京东', pdd: '拼多多', douyin: '抖音',
        kuaishou: '快手', xhs: '小红书', miniapp: '微信小程序',
        website: '官网', app: '独立App', dealer: '经销商体系',
        live: '直播电商', community: '社区/即时零售', strategy: '渠道战略'
      }
      return Object.entries(this.aiData.findings).map(([key, val]) => ({
        label: labels[key] || key,
        found: val.found,
        detail: val.detail
      }))
    }
  },
  methods: {
    ...mapActions('diagnosis', ['setScore', 'resetAll', 'switchTab']),

    getScore(qid) { return this.scores[qid] },
    isBrmSource(qid) { return this.brmSource[qid] },

    getReason(qid) {
      if (!this.aiData || !this.aiData.reasons) return ''
      return this.aiData.reasons[qid] || ''
    },

    pickScore(qid, score) {
      this.setScore({ qid, score, isBrm: false })
    },

    scoreBtnClass(qid, s) {
      if (!(qid in this.scores)) return ''
      if (this.scores[qid] !== s) return ''
      return this.brmSource[qid] ? 'sb' : 'sm'
    },

    confidenceLabel(qid) {
      return CONFIDENCE_LABELS[AI_CONFIDENCE[qid] || 'low']
    },

    aiBadgeClass(qid) {
      return `ai-badge ${AI_CONFIDENCE[qid] || 'low'}`
    },

    findingStyle(found) {
      return found
        ? 'background:rgba(0,245,160,0.05);border:1px solid rgba(0,245,160,0.1);'
        : 'background:rgba(255,59,92,0.05);border:1px solid rgba(255,59,92,0.1);'
    },

    generateReport() {
      this.switchTab('report')
    },

    _brmMaxVal() {
      if (!this.brmData || !this.brmData.platformDetails) return 0
      let max = 0
      Object.values(this.brmData.platformDetails).forEach(v => {
        if (v > max) max = v
      })
      return max
    }
  }
}
</script>
